/**
 * Eventos de marketing (GA4). Sem dados pessoais — apenas nomes de evento
 * e parâmetros não identificáveis. Só dispara quando o gtag está presente
 * (ver `GoogleAnalytics.tsx` / `VITE_GA_MEASUREMENT_ID`).
 */
export type MarketingEvent =
  | "hero_trial_click"
  | "demo_click"
  | "pricing_view"
  | "faq_open"
  | "signup_started"
  | "signup_failed"
  | "campaign_banner_view"
  | "campaign_banner_click"
  | "campaign_countdown_view"
  | "campaign_popup_view"
  | "campaign_popup_close"
  | "campaign_popup_cta_click"
  | "campaign_pricing_view"
  | "pricing_plan_click"
  | "campaign_signup_started"
  | "campaign_signup_completed"
  | "campaign_contract_started"
  | "campaign_contract_completed";


export type ProductEvent =
  | "activation_checklist_dismiss"
  | "activation_step_click"
  | "announcement_reviewed"
  | "announcement_sent"
  | "form_template_applied";

function trackGaEvent(
  event: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (typeof window === "undefined") return;
  window.gtag?.("event", event, params ?? {});
}

export function trackMarketingEvent(
  event: MarketingEvent,
  params?: Record<string, string | number | boolean>,
): void {
  trackGaEvent(event, params);
}

/** Eventos de produto no app. Sem PII — só nome do evento e ids de passo/modelo. */
export function trackProductEvent(
  event: ProductEvent,
  params?: Record<string, string | number | boolean>,
): void {
  trackGaEvent(event, params);
}
